export default "__VITE_ASSET__DqTTsaQC__"